import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { useApp } from "../context/AppContext";
import Reveal from "./Reveal";
import StoryCard from "./StoryCard";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function StoriesTeaser() {
  const { t } = useApp();
  const [stories, setStories] = useState([]);

  useEffect(() => {
    axios.get(`${API}/articles?limit=3`).then((r) => setStories(r.data)).catch(() => {});
  }, []);

  if (!stories.length) return null;
  return (
    <section className="section" id="stories" data-testid="stories-teaser">
      <Reveal>
        <div className="section-head">
          <span className="section-tag">{t("stories.tag")}</span>
          <h2 className="section-title">{t("stories.title")}</h2>
          <p className="section-sub">{t("stories.sub")}</p>
        </div>
      </Reveal>
      <div className="story-grid">
        {stories.map((s, i) => (
          <Reveal key={s.slug} delay={i * 120}>
            <StoryCard story={s} />
          </Reveal>
        ))}
      </div>
      <div className="section-more">
        <Link to="/stories" className="btn-lux-ghost" data-testid="stories-teaser-all">{t("stories.all")}</Link>
      </div>
    </section>
  );
}
